export const timelineCheck = () => {
    const timelineContainer = document.querySelectorAll('.js-timeline-container');
    timelineContainer &&
        timelineContainer.forEach((container) => {
            const timelineItems = container.querySelectorAll('.js-timeline-item-label');
            if (timelineItems) {
                setHeightLabel(timelineItems);
                window.addEventListener('resize', () => {
                    setHeightLabel(timelineItems);
                });
            }
        });
};
const setHeightLabel = (timelineItems) => {
    let maxHeight = 0;
    timelineItems.forEach((item) => {
        item.style.height = '';
    });
    timelineItems.forEach((item) => {
        const itemHeight = item.getBoundingClientRect().height;
        maxHeight = Math.max(maxHeight, itemHeight);
    });
    timelineItems.forEach((item) => {
        item.style.height = `${maxHeight}px`;
    });
};
